import useSWR from "swr";
import API from "../../../axios/instances/API";

const BASE_URL = "dashboard/analytics/retail-reports/quiz-details/?quiz_id=";

const fetcher = async (url) => {
  const { data } = await API.get(url);
  return data;
};

const useModuleDetailsV2 = (id) => {
  const { data, error, mutate, isValidating } = useSWR(
    `${BASE_URL}${id}`,
    fetcher,
    {
      revalidateOnFocus: false,
    },
  );

  return {
    data,
    isValidating,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
};

export default useModuleDetailsV2;
